/* eslint-disable */
import { AlarmsStore } from '../stores/alarms';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { appConfig } from '../settings';
import { IApiParams, apiManager } from '../REST';
import {
    IRequestAPIBody,
    IServerNotificationAPIGETDataItem,
    IServerNotificationAPIGETItemNew,
    IServerNotificationAPIGETNew,
    IServerNotificationGETCountAPI,
    IServerNotificationItem,
} from '../interfaces';
import { getStoreFeatureFlags } from '../middleware';
import { mergeByProperty, num2Fix2 } from '../instruments';

dayjs.extend(relativeTime);

function getAlarmsUnreadShowCount(): number {
    const AlarmsInterface = AlarmsStore.getInstance();
    return AlarmsInterface.showCount;
}

function getAlarmsServerNotificationsRead(): IServerNotificationItem[] {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    return AlarmsStoreInstance.serverNotificationsRead;
}

function setAlarmsServerNotificationRemoveReadItem(id: string): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    const readList = AlarmsStoreInstance.serverNotificationsRead.filter((i) => i.id !== id);
    AlarmsStoreInstance.setServerNotifications(readList, true);
}

export function setAlarmsServerNotificationsIsShowRead(isRead: boolean): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setServerNotificationsIsShowRead(isRead);
}
export function setAlarmsServerNotifications(list: IServerNotificationItem[], isRead: boolean): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();

    if (!isRead) {
        AlarmsStoreInstance.setServerNotifications(list, isRead);
    } else {
        const readCount = getAlarmsUnreadShowCount();
        if (readCount === appConfig.checkServerNotificationsPageSize) {
            AlarmsStoreInstance.setServerNotifications(list, isRead);
        } else {
            const currentList = getAlarmsServerNotificationsRead();
            const newList: IServerNotificationItem[] = mergeByProperty(currentList, list, 'id');
            AlarmsStoreInstance.setServerNotifications(newList, isRead);
        }
    }
}
export function setAlarmsServerNotificationsUnReadCount(count: number): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setServerNotificationsUnReadCount(count);
}
export function setAlarmsServerNotificationsReadCount(count: number): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setServerNotificationsReadCount(count);
}
export function setAlarmsServerNotificationsCountNew(countRead: number, countUnRead: number): void {
    setAlarmsServerNotificationsUnReadCount(countUnRead);
    setAlarmsServerNotificationsReadCount(countRead);
}

export function setAlarmsServerNotificationsCount(count: number, isRead: boolean, countAll: number): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setServerNotificationsCount(count, isRead);
    const isShowRead = AlarmsStoreInstance.isShowServerNotificationsRead;
    // if active read Tabs no calc read count
    if (countAll && ((!isShowRead && !isRead) || (isShowRead && isRead))) {
        AlarmsStoreInstance.setServerNotificationsCount(countAll - count, !isRead);
    }
}

export function setAlarmsShowCountIncrease(): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setShowCountIncrease();
}

export function setAlarmsShowCountReset(): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setShowCountReset();
}

function mapAPIServerNotifications(data: IServerNotificationAPIGETDataItem[]): IServerNotificationItem[] {
    return data.map((value) => {
        const payload = value?.attributes?.payload || {};
        let { balance = 0, threshold = 0, monthly_cost = 0 } = payload;
        const newBalance = +balance?.toFixed(2);
        const newThreshold = +threshold?.toFixed(2);
        const newMonthlyCost = +monthly_cost?.toFixed(2);
        const newPayload = { ...payload, balance: newBalance, threshold: newThreshold, monthly_cost: newMonthlyCost };

        return {
            id: value?.id || 'xxx',
            isRead: value?.attributes?.read,
            event: value?.attributes?.event,
            dateAgo: `${dayjs(value?.attributes?.created_at).fromNow()}`,
            payload: newPayload,
        };
    });
}
function mapAPIServerNotificationsNew(list?: IServerNotificationAPIGETItemNew[]): IServerNotificationItem[] {
    return (
        list?.map((m: IServerNotificationAPIGETItemNew) => {
            const payload = m?.payload || {};
            payload.balance && (payload.balance = num2Fix2(payload.balance));
            payload.threshold && (payload.threshold = num2Fix2(payload.threshold));
            payload.monthly_cost && (payload.monthly_cost = num2Fix2(payload.monthly_cost));

            return {
                id: m.id?.toString() || 'xxx',
                isRead: m.read,
                event: m.event,
                dateAgo: `${dayjs(m.created_at).fromNow()}`,
                payload,
                // payload: mapApi2UiField(m.payload || {}),
            };
        }) || []
    );
}

export async function getServerNotificationsCountNew(): Promise<boolean> {
    const { resp, isError } = await apiManager.getApi('GET_SERVER_NOTIFICATIONS_COUNTERS');
    if (!isError) {
        const { read_count, unread_count } = resp as IServerNotificationGETCountAPI;
        const countRead = read_count || 0;
        const countUnRead = unread_count || 0;
        setAlarmsServerNotificationsCountNew(countRead, countUnRead);
        return !!countUnRead;
    }
    return false;
}

const setServerNotificationsList = (list: IServerNotificationItem[]): void => {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setServerNotificationsList(list);
};
const addServerNotificationsNextPage = (list: IServerNotificationItem[]): void => {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    const currentList = AlarmsStoreInstance.serverNotificationsList;
    const newList: IServerNotificationItem[] = [...currentList, ...list];
    setServerNotificationsList(newList);
};

const setServerNotificationsAllCount = (count: number): void => {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setServerNotificationsAllCount(count);
};
const setServerNotificationsCurrentPage = (page: number): void => {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.setServerNotificationsCurrentPage(page);
};

type IGetServerNotificationsList = {
    isError: boolean;
    list: IServerNotificationAPIGETItemNew[];
    currentPage: number;
    pageSize: number;
    recordsCount: number;
};
type IGetServerNotificationsListProps = {
    isRead: boolean;
    page: number;
    size: number;
};
export async function getServerNotificationsList({
    isRead,
    size,
    page,
}: IGetServerNotificationsListProps): Promise<IGetServerNotificationsList> {
    const params: IApiParams = { searchParamsList: { read: `${isRead}`, pageSize: size, pageNumber: page } };
    const { resp, isError } = await apiManager.getApi('GET_SERVER_NOTIFICATIONS_NEW', params);
    const { company_notifications, meta } = resp as IServerNotificationAPIGETNew;
    return {
        isError,
        list: company_notifications || [],
        currentPage: Number(meta?.page) || 0,
        pageSize: Number(meta?.per_page) || 0,
        recordsCount: Number(meta?.records_count) || 0,
    };
}
type IGetServerNotificationsPageList = {
    isRead: boolean;
    pageNumber: number;
    isNextPage: boolean;
};

export async function getServerNotificationsPageList({
    isRead,
    pageNumber,
    isNextPage,
}: IGetServerNotificationsPageList): Promise<void> {
    const pageS = appConfig.checkServerNotificationsPageSize;
    const { isError, list, currentPage, recordsCount } = await getServerNotificationsList({
        isRead,
        page: pageNumber,
        size: pageS,
    });
    if (!isError) {
        setServerNotificationsCurrentPage(currentPage);
        setServerNotificationsAllCount(recordsCount);
        if (isRead) {
            setAlarmsServerNotificationsReadCount(recordsCount);
        } else {
            setAlarmsServerNotificationsUnReadCount(recordsCount);
        }
        const mapList = mapAPIServerNotificationsNew(list);
        if (isNextPage) {
            addServerNotificationsNextPage(mapList);
        } else {
            setServerNotificationsList(mapList);
        }
    }
}

export function getServerNotificationsFirstPage(isRead: boolean): void {
    getServerNotificationsPageList({ isRead, pageNumber: 1, isNextPage: false });
}
export function getServerNotificationsNextPage(isRead: boolean): void {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    const currentPage = AlarmsStoreInstance.serverNotificationsCurrentPage;
    getServerNotificationsPageList({ isRead, pageNumber: currentPage + 1, isNextPage: true });
}
export async function getServerNotificationsFullPage(isRead: boolean): Promise<void> {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    const currentPage = AlarmsStoreInstance.serverNotificationsCurrentPage;
    const pageSize = appConfig.checkServerNotificationsPageSize;
    const pageMax = appConfig.checkServerNotificationsMaxPageSize;

    const fullList: IServerNotificationItem[] = [];
    const requestCount = Math.ceil((currentPage * pageSize) / pageMax);
    let newRecordsCount = requestCount;

    for (let i = 1; i <= requestCount; i++) {
        const { isError, list, recordsCount } = await getServerNotificationsList({
            isRead,
            page: i,
            size: pageMax,
        });
        if (!isError) {
            const mapList = mapAPIServerNotificationsNew(list);
            fullList.push(...mapList);
            newRecordsCount = recordsCount;
        }
    }
    if (fullList.length > currentPage * pageSize) {
        fullList.length = currentPage * pageSize;
    }
    await getServerNotificationsCountNew();
    setServerNotificationsAllCount(newRecordsCount);
    setServerNotificationsList(fullList);
}

export async function getServerNotifications(isRead: boolean): Promise<number> {
    const params: IApiParams = {
        searchParamsList: { read: `${isRead}` },
    };

    if (!isRead && params.searchParamsList) {
        params.searchParamsList.stream = `${!isRead}`;
    }

    if (isRead && params.searchParamsList) {
        params.searchParamsList.pageSize = appConfig.checkServerNotificationsPageSize;
        params.searchParamsList.pageNumber = getAlarmsUnreadShowCount() / appConfig.checkServerNotificationsPageSize;
    }

    const { resp, isError } = await apiManager.getApi('GET_SERVER_NOTIFICATIONS', params);

    if (!isError) {
        resp?.data &&
            setAlarmsServerNotifications(
                mapAPIServerNotifications(resp.data as IServerNotificationAPIGETDataItem[]),
                isRead,
            );
        resp?.meta &&
            setAlarmsServerNotificationsCount(
                Number(resp?.meta?.records_count),
                isRead,
                Number(resp?.meta?.total_count),
            );
    }

    return Number(resp?.meta?.records_count);
}

export async function getServerNotificationsFirstStart(): Promise<void> {
    const unreadCount = await getServerNotifications(false);

    if (unreadCount) {
        setIsPopupOpen(true);
    }
}

export async function changeStatusServerNotificationsItemNew(id: string, isNewRead: boolean): Promise<void> {
    const body: IRequestAPIBody = { read: isNewRead };
    const { isError } = await apiManager.getApi('PATCH_SERVER_NOTIFICATION_NEW', { id }, body);
    if (!isError) {
        await getServerNotificationsFullPage(!isNewRead);
    }
}
export async function changeStatusServerNotificationsItem(id: string, isRead: boolean): Promise<void> {
    const body: IRequestAPIBody = {
        data: {
            id,
            attributes: { read: isRead },
            type: 'company_notification',
        },
    };

    const { isError } = await apiManager.getApi('PATCH_SERVER_NOTIFICATION', { id }, body);

    if (!isError) {
        if (!isRead) {
            setAlarmsServerNotificationRemoveReadItem(id);
        }
        await getServerNotifications(!isRead);
    }
}
const cleanServerNotificationsStore = (): void => {
    const AlarmsStoreInstance = AlarmsStore.getInstance();
    AlarmsStoreInstance.cleanServerNotificationsStore();
};
export const resetServerNotificationsStore = (): void => {
    cleanServerNotificationsStore();
    const { newAlarms } = getStoreFeatureFlags();
    if (newAlarms) {
        getServerNotificationsCountNew();
    } else {
        getServerNotifications(false);
    }
};

export function setIsPopupOpen(isOpen: boolean): void {
    const AlarmsInterface = AlarmsStore.getInstance();
    AlarmsInterface.setIsPopupOpen(isOpen);
    if (!isOpen) {
        resetServerNotificationsStore();
    }
}
